module.exports = __webpack_public_path__ + "images/help/plane-956fa197f2a7ed0908c3a994c3a9fecc.png";